export default __webpack_public_path__ + "2e9c40ba6d1b8c9910509afb63d33e27.svg";